// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3p0wt","requiredAsterisk":"Info_requiredAsterisk__24gpU"};